import { GetEquipmentByIdResponseSchema } from '@shared/schema/equipment.get-by-id.schema'
import { queryOptions } from '@tanstack/react-query'

import { QueryOptionsData } from '@/@types/query'
import { apiFetch } from '@/lib/api-fetch'

export function equipmentByIdQuery(siteId: number, equipmentId: string) {
  return queryOptions({
    queryKey: ['site', siteId, 'equipment', 'by-id', equipmentId],
    async queryFn() {
      const rawResponse = await apiFetch.get(`site/${siteId}/equipment/by-id/${equipmentId}`)

      if (!rawResponse.ok) {
        throw new Error(`Failed to fetch equipment ${equipmentId}`)
      }

      try {
        return await GetEquipmentByIdResponseSchema.parseAsync(await rawResponse.json())
      } catch (error) {
        throw new Error('Failed to parse equipment by id response', { cause: error })
      }
    },
  })
}

export type EquipmentById = QueryOptionsData<typeof equipmentByIdQuery>
